import React from "react";
import { cn } from "@/lib/utils";

const COLOR_BG = {
  violet: "bg-violet-500", emerald: "bg-emerald-500", blue: "bg-blue-500",
  amber: "bg-amber-500", rose: "bg-rose-500", teal: "bg-teal-500",
  indigo: "bg-indigo-500", orange: "bg-orange-500", cyan: "bg-cyan-500",
  fuchsia: "bg-fuchsia-500", lime: "bg-lime-600", sky: "bg-sky-500",
  pink: "bg-pink-500", green: "bg-green-600", slate: "bg-slate-500",
};

export const AVATAR_COLOR_KEYS = Object.keys(COLOR_BG).filter((k) => k !== "slate");
export const AVATAR_BG = COLOR_BG;

export function initialsOf(name = "") {
  const parts = (name || "?").trim().split(/\s+/).filter(Boolean);
  return (parts.slice(0, 2).map((w) => w[0]).join("") || "?").toUpperCase();
}

const SIZES = {
  xs: "h-5 w-5 text-[9px]", sm: "h-6 w-6 text-[10px]",
  md: "h-8 w-8 text-[11px]", lg: "h-10 w-10 text-sm",
};

export function UserAvatar({ name, color = "slate", size = "sm", className, title }) {
  return (
    <span
      title={title || name || ""}
      className={cn("inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-white", SIZES[size] || SIZES.sm, COLOR_BG[color] || COLOR_BG.slate, className)}
      data-testid="user-avatar"
    >
      {initialsOf(name)}
    </span>
  );
}

// Avatar + nombre en línea, para atribuir acciones ("por X").
export function UserChip({ name, color = "slate", size = "xs", className }) {
  if (!name) return null;
  return (
    <span className={cn("inline-flex items-center gap-1 align-middle", className)}>
      <UserAvatar name={name} color={color} size={size} />
      <span className="truncate font-medium">{name}</span>
    </span>
  );
}
